import { BadgeCheck, Languages, Building } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const ICONS = [BadgeCheck, Languages, Building];

export const WhyUs = () => {
  const { t } = useLanguage();

  return (
    <section id="de-ce-noi" className="bg-[#0d2b52] py-20 lg:py-28" data-testid="why-us-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="section-label !text-[#2f9be8]" data-testid="why-us-label">
          {t.whyUs.label}
        </p>
        <h2
          className="font-display mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl"
          data-testid="why-us-title"
        >
          {t.whyUs.title}
        </h2>

        <div className="mt-14 grid gap-px bg-white/10 md:grid-cols-3">
          {t.whyUs.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <article
                key={i}
                className="bg-[#0d2b52] p-8 transition-colors hover:bg-[#123a6b]"
                data-testid={`why-us-card-${i}`}
              >
                <span className="font-display text-5xl font-bold text-[#2f9be8]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="mt-6 flex items-center gap-3">
                  <Icon className="h-6 w-6 text-[#2f9be8]" />
                  <h3 className="font-display text-xl font-bold text-white">{item.title}</h3>
                </div>
                <p className="mt-3 leading-relaxed text-[#cbd5e1]">{item.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
